import { createRouter, createWebHistory } from 'vue-router'
// 页面组件
import Home from '@/views/Home.vue'
import NewsList from '@/views/NewsList.vue';
import NewsEditor from '@/components/NewsEditor.vue';
import { useAuthStore } from '@/stores/auth'
const SITE_NAME = '烟台先进材料与绿色制造山东省实验室'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: `首页 -` +  SITE_NAME
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginSys.vue'),
    meta: {
      title: `管理登录系统 -` +  SITE_NAME
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/RegisterSys.vue'),
    meta: {
      title: `管理注册系统 -` +  SITE_NAME
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: {
      title: '实验室介绍 - ' + SITE_NAME
    } 
  },
  {
    path: '/about/structure',
    name: 'AboutArchitecture',
    component: () => import('@/views/AboutArchitecture.vue'),
    meta: {
      title: '组织架构 - ' + SITE_NAME
    }
  },
  { 
    path: '/about/leader',
    name: 'AboutLeaders',
    component: () => import('@/views/AboutLeaders.vue'),
    meta: {
      title: '领导团队 - ' + SITE_NAME
    }
  },
  {
    path: '/about/campus',
    name: 'AboutCampuss',
    component: () => import('@/views/AboutCampuss.vue'),  
    meta: {
      title: '园区风貌 - ' + SITE_NAME
    }
  },
  {
    path: '/about/video',
    name: 'AboutVideos',
    component: () => import('@/views/AboutVideos.vue'),  
    meta: {
      title: '宣传视频 - ' + SITE_NAME
    }
  },
  {
    path: '/about/contact',
    name: 'AboutContacts',
    component: () => import('@/views/AboutContacts.vue'), 
    meta: {
      title: '联系我们 - ' + SITE_NAME
    }
  },
  {
    path: '/research',
    name: 'Research',
    component: () => import('@/views/Research.vue'), 
    meta: {
      title: '研究系统 - ' + SITE_NAME
    }
  },
  {
    path: '/research/platform',
    name: 'Platform',
    component: () => import('@/views/Platform.vue'), 
    meta: {
      title: '公共研发平台 - ' + SITE_NAME
    }
  },
  {
    path: '/research/center',
    name: 'ResearchCenters',
    component: () => import('@/views/ResearchCenters.vue'), 
    meta: {
      title: '研究中心 - ' + SITE_NAME
    }
  },
  {
    path: '/research/joint',
    name: 'JointCenter',
    component: () => import('@/views/JointCenter.vue'),
    meta: {
      title: '联合研究中心 - ' + SITE_NAME
    }
  },
  {
    path: '/research/service',
    name: 'PublicTechnology',
    component: () => import('@/views/PublicTechnology.vue'), 
    meta: {
      title: '公共技术服务 - ' + SITE_NAME
    }
  },
  {
    path: '/application/materials',
    name: 'MaterialsApplication',
    component: () => import('@/views/MaterialsApplication.vue'), 
    meta: {
      title: '先进材料 - ' + SITE_NAME
    }
  },
  {
    path: '/application/manufacturing',
    name: 'ManufacturingApplication',
    component: () => import('@/views/ManufacturingApplication.vue'), 
    meta: {
      title: '绿色制造 - ' + SITE_NAME
    }
  },
  {
    path: '/news/centers',
    name: 'NewsCenters',
    component: () => import('@/views/NewsCenters.vue'), 
    meta: {
      title: '新闻资讯 - ' + SITE_NAME
    }
  },
  {
    path: '/news/general',
    name: 'NewsGeneral',
    component: () => import('@/views/NewsGenerals.vue'),
    meta: {
      title: '综合新闻 - ' + SITE_NAME
    }
  },
  {
    path: '/news/cooperation',
    name: 'NewsCooperation',
    component: () => import('@/views/NewsCooperations.vue'),
    meta: {
      title: '合作交流 - ' + SITE_NAME
    }
  },
  {
    path: '/news/sciences',
    name: 'NewsScience',
    component: () => import('@/views/NewsSciences.vue'),
    meta: {
      title: '科研动态 - ' + SITE_NAME
    }
  },
  {
    path: '/news/science',
    name: 'NewsScience',
    component: () => import('@/views/NewsKepuGrids.vue'),
    meta: {
      title: '科普动态 - ' + SITE_NAME
    }
  },
  { 
    path: '/news/party',
    name: 'NewsParty',
    component: () => import('@/views/NewsParties.vue'),
    meta: {
      title: '党建动态 - ' + SITE_NAME
    }
  },
  {
    path: '/announcement/open-topic',
    name: 'AnnouncementsTopics',
    component: () => import('@/views/AnnouncementsTopics.vue'),
    meta: {
      title: '开放课题 - ' + SITE_NAME
    }
  },
  {
    path: '/announcement/notice',
    name: 'AnnouncementsNotice',
    component: () => import('@/views/AnnouncementsNotice.vue'), 
    meta: {
      title: '通知公告 - ' + SITE_NAME
    }
  },
  {
    path: '/news/manager',
    name: 'NewsManage',
    component: () => import('@/views/NewsManage.vue'),
    meta: {
      title: '新闻管理 - ' + SITE_NAME
    }
  },
  { path: '/news', 
    component: NewsList,
    meta: {
      title: '新闻列表 - ' + SITE_NAME
    }
  },
  { path: '/news/edit/:id?', 
    component: NewsEditor,
    meta: {
      title: '新闻编辑 - ' + SITE_NAME
    }
  },
  {
  path: '/news/editor',
  component: () => import('@/views/NewsEditor.vue'),
  meta: {
      title: '新闻 - ' + SITE_NAME
  }
  },
  {
  path: '/news/editor/:id?',
  name: 'NewsEditor',
  component: () => import('@/views/NewsEditor.vue'),
      meta: {
      title: '新闻 - ' + SITE_NAME
    }
  },
  {
  path: '/news/:id',
  name: 'NewsDetail',
  component: () => import('@/views/NewsDetail.vue'),
  meta: {
    title: '新闻详情 - ' + SITE_NAME
  }
  },
  {
  path: '/notice/:id',
  name: 'AnnountionDetail',
  component: () => import('@/views/AnnountionDetail.vue'),
  meta: {
      title: '通知公告 - ' + SITE_NAME
  }
  },
    {
  path: '/topic/:id',
  name: 'TopicDetail',
  component: () => import('@/views/AnnountionDetail.vue'),
  meta: {
      title: '开放课题 - ' + SITE_NAME
  }
  },
  {
  path: '/job/:id',
  name: 'JobDetail',
  component: () => import('@/views/NewsDetail.vue'),
  meta: {
      title: '招聘信息 - ' + SITE_NAME
  }
},
  {
  path: '/newsearch',
  name: 'NewSearch',
  component: () => import('@/views/NewSearch.vue'),
  meta: {
      title: '新闻搜索 - ' + SITE_NAME
  }
},
  {
  path: '/offers',
  name: 'Offers',
  component: () => import('@/views/Rencai.vue'),
  meta: {
      title: '招聘信息 - ' + SITE_NAME
  }
}
]
const router = createRouter({
  history: createWebHistory(),
  routes
})
// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   next()
// })
router.beforeEach((to, from, next) => {
  const auth = useAuthStore()
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.requiresAuth && !auth.isLogin) {
    // 如果需要登录并且用户没有登录，跳转到登录页
    next('/login')
  } else {
    next() // 放行
  }
})
export default router
// export default router
